import React, { Component } from "react";
import Firebase from "./components/Firebase/Firebase";
import Prismic from "./components/Prismic/Prismic";
import Routing from "./Routing";

class App extends Component {
	render() {
		return (
			<Firebase>
				<Prismic>
					<Routing />
				</Prismic>
			</Firebase>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js